// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__BRH9k","table":"table_table__fyyP6","tableSticky":"table_tableSticky__uj6s3","emptyTable":"table_emptyTable__6RO9W"};